import { useEffect } from "react";

import { Button, Grid2, Typography } from "@mui/material";
import { useForm } from "react-hook-form";

import { validators } from "../../../../utils";
import { CommonInput } from "../../../common";

export type TSummaryFieldValues = {
	airHours: string;
	simulatorHours: string;
	milesFlown: string;
	flightSummary: string;
};

export function Summary() {
	const { control, reset } = useForm<TSummaryFieldValues>({
		defaultValues: {
			airHours: "",
			simulatorHours: "",
			milesFlown: "",
			flightSummary: "",
		},
	});

	useEffect(() => {
		reset({
			airHours: "",
			simulatorHours: "",
			milesFlown: "",
			flightSummary: "",
		});
	}, [reset]);

	const onClickCancel = () => {
		reset({
			airHours: "",
			simulatorHours: "",
			milesFlown: "",
			flightSummary: "",
		});
	};

	return (
		<div className="summary-container item-separator-big">
			<form>
				<Grid2 container spacing={2}>
					<Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
						<Typography className="normal-text bold">Air Hours</Typography>
						<div className="item-separator-tiny" />
						<CommonInput
							control={control}
							placeholder="Air Hours"
							name="airHours"
							rules={{
								pattern: {
									value: validators.number,
									message: "",
								},
							}}
							disallowInvalidInput
							suffix="hrs"
						/>
					</Grid2>
					<Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
						<Typography className="normal-text bold">
							Simulator Hours
						</Typography>
						<div className="item-separator-tiny" />
						<CommonInput
							control={control}
							placeholder="Simulator Hours"
							name="simulatorHours"
							rules={{
								pattern: {
									value: validators.number,
									message: "",
								},
							}}
							disallowInvalidInput
							suffix="hrs"
						/>
					</Grid2>
					<Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
						<Typography className="normal-text bold">Miles Flown</Typography>
						<div className="item-separator-tiny" />
						<CommonInput
							control={control}
							placeholder="Miles Flown"
							name="milesFlown"
							rules={{
								pattern: {
									value: validators.number,
									message: "",
								},
							}}
							disallowInvalidInput
							suffix="mi"
						/>
					</Grid2>
					<Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Typography className="normal-text bold">Follow-up</Typography>
						<div className="item-separator-tiny" />
						<CommonInput
							control={control}
							placeholder="Students love feedback, tips, and personal assignments. What can you pass on to the student to accelerate learning?"
							name="flightSummary"
							multiline
						/>
					</Grid2>
				</Grid2>
				<div
					className="item-separator-small"
					style={{
						display: "flex",
						gap: "16px",
						justifyContent: "flex-end",
						alignItems: "center",
					}}>
					<Button
						className="summary-button normal-button disabled-button"
						onClick={onClickCancel}>
						Cancel
					</Button>
					<Button className="summary-button normal-button primary-button">
						Save
					</Button>
				</div>
			</form>
		</div>
	);
}
